import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";

function standardOneToOneValidation() {
    return {
        minIncoming: 1,
        maxIncoming: 1,
        minOutgoing: 1,
        maxOutgoing: 1
    };
}

export const SELECTED_PLUGIN_INFORMATION_DATA = [
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_ASSIGN,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_ASSIGN,
        name: "Assign",
        description: "Assignment plugin",
        color: "#F2BD46",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DECLARE,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_DECLARE,
        name: "Declare",
        description: "Variable declaration plugin",
        color: "#F2BD46",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FUNCTION_CALL,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_FUNCTION_CALL,
        name: "Call Function",
        description: "Function Call Plugin",
        color: "#CC4774",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EMIT_EVENT,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_EMIT_EVENT,
        name: "Emit Event",
        description: "Emit Event Plugin",
        color: "#4747CC",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EXPRESSION,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_EXPRESSION,
        name: "Custom",
        description: "Expression Plugin",
        color: "#F2BD46",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_IF,
        name: "If",
        description: "If statement",
        color: "#BF4AE2",
        validations: {
            minIncoming: 1,
            maxIncoming: 1,
            minOutgoing: 1,
            maxOutgoing: 2
        }
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_DO_WHILE,
        name: "Do While",
        description: "Do while loop ",
        color: "#444444",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_WHILE,
        name: "While",
        description: "While loop",
        color: "#00B55B",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_FOR,
        name: "For",
        description: "For loop",
        color: "#256BDE",
        validations: standardOneToOneValidation()
    },
    {
        id: SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR,
        typeId: SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR,
        name: "Delimitator",
        description: "Code block delimitator",
        color: "#256BDE",
        validations: {
            minIncoming: 1,
            maxIncoming: 2,
            minOutgoing: 1,
            maxOutgoing: 1,
            mandatory: false, // custom
            maxInstances: 1000, // custom
            minInstances: 1 // custom
        }
    },
    {
        id: SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN,
        typeId: SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN,
        name: "Start",
        description: "Function Start indicator",
        color: "#63D471",
        validations: {
            minIncoming: 0,
            maxIncoming: 0,
            minOutgoing: 1,
            maxOutgoing: 1,
            mandatory: true,
            maxInstances: 1,
            minInstances: 1
        }
    },
    {
        id: SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN,
        typeId: SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN,
        name: "End",
        description: "Function End Indicator",
        color: "#D15656",
        validations: {
            minIncoming: 1,
            maxIncoming: 1,
            minOutgoing: 0,
            maxOutgoing: 0,
            mandatory: true,
            maxInstances: 1,
            minInstances: 1
        }
    }
];
